// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__3DeO-","label":"CategoryService_label__23nbC","location":"CategoryService_location__2VsIB"};